import { render, staticRenderFns } from "./detail-only-stay.vue?vue&type=template&id=ca9ac6d6"
import script from "./detail-only-stay.vue?vue&type=script&lang=js"
export * from "./detail-only-stay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports